module.exports = __webpack_public_path__ + "static/media/grid.inactive.e7c2887d.svg";